// extracted by mini-css-extract-plugin
export var closeButton = "_le-1";
export var closeX = "_le-3";
export var container = "_le-0";
export var image = "_le-2";